export default __webpack_public_path__ + "static/media/unidadesBgMob.bcc218a7.png";